"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.remove = exports.set = exports.get = void 0;
var type_1 = require("./type");
var Converter = {
    read: function (value) {
        return value.replace(/%3B/g, ';');
    },
    write: function (value) {
        return String(value).replace(/;/g, '%3B');
    },
};
function get(key) {
    if (typeof document === 'undefined' || (arguments.length && !key)) {
        return;
    }
    var cookies = document.cookie ? document.cookie.split('; ') : [];
    var jar = {};
    for (var i = 0; i < cookies.length; i++) {
        var parts = cookies[i].split('=');
        var value = parts.slice(1).join('=');
        var foundKey = Converter.read(parts[0]).replace(/%3D/g, '=');
        jar[foundKey] = Converter.read(value);
        if (key === foundKey) {
            break;
        }
    }
    return key ? jar[key] : jar;
}
exports.get = get;
function set(key, value, options) {
    if (options === void 0) { options = {}; }
    if (typeof document === 'undefined') {
        return;
    }
    options = Object.assign({}, {
        path: '/',
    }, options);
    if ((0, type_1.isNumber)(options.expires)) {
        options.expires = new Date(Date.now() + options.expires * 86400000);
    }
    if (options.expires && (0, type_1.isDate)(options.expires)) {
        options.expires = options.expires.toUTCString();
    }
    value = Converter.write(value);
    key = Converter.write(key).replace(/=/g, '%3D');
    var stringifiedAttributes = '';
    for (var _i = 0, _a = Object.entries(options); _i < _a.length; _i++) {
        var _b = _a[_i], k = _b[0], v = _b[1];
        if (!v) {
            return;
        }
        stringifiedAttributes += "; ".concat(k);
        stringifiedAttributes += "=".concat(v.split(';')[0]);
    }
    return (document.cookie = "".concat(key, "=").concat(value).concat(stringifiedAttributes));
}
exports.set = set;
function remove(key, options) {
    set(key, '', Object.assign({}, options, {
        expires: -1,
    }));
}
exports.remove = remove;
exports.default = {
    get: get,
    set: set,
    remove: remove,
};
